export const PAYMENT_METHOD_POS_TYPES = ['leaflogix'] as const;
export type SupportedPosType = typeof PAYMENT_METHOD_POS_TYPES[number];

export const PAYMENT_METHOD_TO_DISPLAY = {
  pay_by_bank: 'Pay By Bank',
};

export const PAYMENT_METHOD_TYPES = ['pay_by_bank'] as const;
export type PaymentMethodType = typeof PAYMENT_METHOD_TYPES[number];
